import { useState } from 'react';
import { useI18n } from '../lib/i18n';
import { openShare, trackShare, type ShareChannel, type ShareInput } from '../lib/share';

export function ShareMenu({ input }: { input: ShareInput }) {
  const { t } = useI18n();
  const [toast, setToast] = useState<string | null>(null);

  const channels: { id: ShareChannel; label: string }[] = [
    ...(typeof navigator !== 'undefined' && 'share' in navigator
      ? ([{ id: 'native', label: t('app.share.native') }] as const)
      : []),
    { id: 'whatsapp', label: t('app.share.whatsapp') },
    { id: 'copy', label: t('app.share.copy') },
    { id: 'instagram', label: t('app.share.instagram') },
    { id: 'facebook', label: t('app.share.facebook') },
    { id: 'x', label: t('app.share.x') },
    { id: 'email', label: t('app.share.email') },
  ];

  async function onClick(c: ShareChannel) {
    trackShare(input, c);
    try {
      const r = await openShare(c, input);
      if (r === 'copied') {
        setToast(t('app.share.copied'));
        setTimeout(() => setToast(null), 1600);
      }
    } catch {
      /* user cancelled share — silent */
    }
  }

  return (
    <div className="relative">
      <h4 className="display mb-2 text-[11px] uppercase tracking-[0.2em] text-an-muted">
        {t('app.panel.share')}
      </h4>
      <div className="flex flex-wrap gap-1.5">
        {channels.map((c) => (
          <button
            key={c.id}
            type="button"
            onClick={() => onClick(c.id)}
            className="display border border-an-rule bg-an-white px-2.5 py-1 text-[11px] uppercase tracking-wider hover:bg-an-black hover:text-an-white"
          >
            {c.label}
          </button>
        ))}
      </div>
      {toast && (
        <div
          role="status"
          className="pointer-events-none absolute -top-9 left-0 rounded-sm bg-an-black px-2 py-1 text-[11px] text-an-white shadow"
        >
          {toast}
        </div>
      )}
    </div>
  );
}
